<template>
    <div class="fst-Compare">
        <Header mode="compare"
                @showHelp="handleShowHelp('CompareByFilter')"></Header>
        <div v-loading.fullscreen.lock="loading">
            <el-tabs type="" v-model="activeName" class="topTabs">
                <el-tab-pane name="compareByFilter" :label="$t('compare.compareByFilter')">
                    <div class="topControl">
                        <el-button @click="handleGetQuery('single')" type="primary">{{$t('compare.pickQuery')}}
                        </el-button>
                        <template v-if="(queries || [])[0]">
                            <div class="title">{{queries[0].name}}</div>
                            <div class="docType">{{$t('compare.docType')}}: <span>{{queries[0].types[0]}}</span></div>
                            <div class="query">{{$t('compare.query')}}:
                                <query-widget :q="queries[0]"></query-widget>

                            </div>
                        </template>
                        <div class="flex-center ml-auto">
                            <el-select v-model="selectedPopularQuery"
                                       v-if="popQueriesOpts.length"
                                       @change="addPopularQuery"
                                       clearable
                                       :placeholder="$t('compare.popularQueries')"
                                       class="mr-2 ml-4">
                                <el-option v-for="(opt, key) in popQueriesOpts" :key="key"
                                        :value="opt.value"
                                        :label="opt.label"
                                ></el-option>
                            </el-select>
                            <el-button type="secondary" circle
                                       @click="handleShowHelp('CompareByFilter')"
                                       icon="fas fa-fw fa-question"></el-button>
                        </div>
                    </div>
                    <compare-search-queries ref="compareByFilter"
                            @addToComparison="addToComparison"
                            :facets="facets" mode="single"
                            :queries="queries"></compare-search-queries>
                </el-tab-pane>
                <el-tab-pane name="compareQueries" :label="$t('compare.compareQueries')">
                    <div class="topControl">
                        <el-button @click="handleGetQuery('multiple')" type="primary">{{$t('compare.pickQueries')}}
                        </el-button>
                        <el-button type="secondary" circle
                                   @click="handleShowHelp('CompareByFilter')"
                                   class="ml-auto"
                                   icon="fas fa-fw fa-question"></el-button>
                    </div>
                    <compare-search-queries :facets="facets" :queries="queries"></compare-search-queries>

                </el-tab-pane>
            </el-tabs>
        </div>
        <get-saved-query ref="getSavedQuery" @selectedQueries="handleSelectQueries"></get-saved-query>
    </div>
</template>

<script>
    import Header from "../components/Header";
    import {mapState} from "vuex";
    import GetSavedQuery from "../components/compare/GetSavedQuery";
    import SearchFacets from "../components/search/SearchFacets";
    import _ from "lodash";
    import CompareSearchQueries from "../components/compare/CompareSearchQueries";
    import QueryWidget from "../components/compare/QueryWidget";
    import mixins from "../components/common/mixin";


    export default {
        name: "Compare",
        mixins: [mixins],
        components: {QueryWidget, CompareSearchQueries, GetSavedQuery, Header},
        computed: {
            allowed() {
                return this.$store.state.allowedActions;
            },

        },
        watch: {
            activeName() {
                this.queries = [];
                this.facets = [];
                this.$refs.getSavedQuery.reset();
            }
        },
        mounted() {
            // console.log("----- facetParam -----", this.facetParam);
            this.loading = true;
            this.$store.dispatch('notions').then(() => {
                this.loading = false;
                this.popQueriesOpts = _.map(_.pickBy(this.popularQueries, q => (!q.restriction || this.allowed.contains(q.restriction))),
                    (popQ, alias) => {
                        return {
                            label: popQ.title,
                            value: alias
                        }
                    })
                // console.log('pop Opts', this.popQueriesOpts)
            })
        },
        data() {
            return {
                loading: false,
                selectedPopularQuery: '',
                popQueriesOpts: [],
                activeName: 'compareByFilter',
                facetParam: _.keyBy(SearchFacets.data().facetParam, 'id'),
                facets: [],
                queries: [],
            }
        },
        methods: {
            getFacets(filters = []) {
                // console.log('this.facetParam[filter.types[0]]', this.facetParam, this.facetParam['Science'])
                let facetParamItems = {};
                this.loading = true;
                filters = filters.map(filter => {
                    facetParamItems = _.keyBy(this.facetParam[filter.types[0] || q.docType].items, 'id')
                    filter.facets = filter.facets || {}
                    filter.facets.requests = filter.facets.requests ? filter.facets.requests.map(facet => {
                        facet.calculate = true;
                        return facet
                    }) : _.map((facetParamItems || []), facet => {
                        return {
                            type: facet.type,
                            calculate: true,
                            facetId: facet.facetId || null
                        }
                    })
                    return filter
                })
                // console.log('--- ::filters:: --- ', filters)

                this.$services.analytics.facetCompare({filters: filters}).then(resp => {
                    this.facets = resp.data.facets.map(facet => {
                        let _fpI = facetParamItems[facet.type + (facet.facetId || '')] || {};
                        _.merge(facet, _fpI);
                        let _title = (facet.title || facet.facetId || facet.type || '').toLowerCase().replace(/\s/g, '_');
                        facet.title = this.$t('facets.' + _title) || facet.title;
                        facet.items = facet.items ? facet.items.filter(it => {
                            return (!facet.isBoolean || it.value)
                        }).map(item => {
                            return this.formatFacetItem(item, facet)
                        }) : [];
                        return facet
                    })
                    this.loading = false;
                    // console.log('--- FACETS --- ', this.facets)
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                })
            },
            handleGetQuery(mode) {
                this.$refs.getSavedQuery.visible = true;
                this.$refs.getSavedQuery.mode = mode;
            },
            handleSelectQueries({mode, queries}) {
                // console.log('M:', mode, 'Q:', queries)
                this.queries = queries;
                this.getFacets(queries)
            },
            addToComparison(selectedItems = []) {
                let newFilter = _.cloneDeep(this.queries[0]);
                selectedItems.forEach(item => {
                    let itemBlock = newFilter.facets.requests.find(r => {
                        return r.type === item.type && (!item.facetId || item.facetId === r.facetId)
                    })
                    itemBlock.values = itemBlock.values || []
                    itemBlock.values.push(item.value)
                })
                newFilter.selectedItems = _.map(selectedItems, it => {
                    return _.upperFirst((it.value || '').replace(/_/g, ' ') || 'undefined');
                })
                // console.log(':::: newFilter', newFilter);
                this.queries.push(newFilter)
                this.getFacets(this.queries)
            },
            addPopularQuery(q) {
                this.facets = []
                this.queries = []
                let popQ = this.popularQueries[q],
                    result = this.createFacetRequest(popQ);
                if(result) {
                    this.queries = result;
                    this.getFacets(this.queries)
                }
            },
            formatFacetItem(item, facet) {
                let value = item.value || null;
                let _name = item.name || item.value,
                    alias = {
                        'm&a': 'M&A',
                        'M&A': 'M&A',
                        ipo: 'IPO',
                        venture: 'Venture',
                        friendly: this.$t('facets.values.friendly'),
                        unfriendly: this.$t('facets.values.unfriendly'),
                    },
                    tooltip = _name;
                // let selected = _.isObject(value) ? selectedItems.some(item => _.isEqual(item, value))
                //     : isBoolean ? facet.value
                //         : selectedItems.includes((value ? (value || '').toLowerCase() : value)) || selectedItems.includes(value);
                let name = _.isString(_name) && !facet.rawName ? (alias[_name] ? alias[_name]
                    : (facet.nameToStartCase ? _.startCase(_name)
                        : _.upperFirst(_name.replace(/_/g, ' '))))
                    : _name;
                if (facet.type.includes('CPC_')) {
                    name = this.$utils.cpcNameFormat(name, 'full');
                } else if (facet.isBoolean) {
                    name = this.$t('facets.' + (item.value ? facet.names[0] : facet.names[1]))
                }
                let docCountRaw = item.docCountRaw || item.docCount;
                return _.merge({}, item, {
                    name: name,
                    title: tooltip,
                    // tagName: `${facet.title} / ${name}`,
                    tagName: `${name}`,
                    value: value,
                    valueOrd: value ? value : '0',
                    selected: false,
                    iso: (facet.type === 'COUNTRIES' || facet.isCountry) ? this.$utils.countryToISO((item.value || '').toLowerCase()) : '',
                    popover: false,
                    docCountRaw: docCountRaw,
                    docCount: docCountRaw.map(count => {
                        return count ? this.$utils.numbers.format(count) : '-'
                    }),
                    parent: _.pick(facet, ['title', 'type', 'facetId', 'isBoolean'])
                });
            },

        }
    }
</script>

<style lang="scss">
    .fst-Compare {
        background: $iq-color-blue-lighter;
        min-height: 100vh;

        .fst-Header .appMode {
            &.locale-en {
                input[type="text"] {
                    width: 100px;
                }
            }

            &.locale-ru {
                input[type="text"] {
                    width: 120px;
                }
            }
        }


        .topTabs {
            .el-tabs__header {
                background: #fff;

                .el-tabs__active-bar {
                    padding: 0 0 0 15px;
                }

                .el-tabs__item {
                    padding-right: 0;

                    &:before {
                        content: ' ';
                        display: inline-block;
                        width: 15px;
                    }
                }
            }

            .el-tabs__content {
                padding: 0 15px;
                width: 80vw;
                margin: 0 auto;
            }

            .docType {
                span {
                    font-size: 13px;
                    background: #D6E3FF;
                    border-radius: 4px;
                    padding: 3px 4px;
                    font-weight: 500;
                }
            }
        }


        .compareMain {
            background: #ffffff;
            border-radius: 6px;
            padding: 10px 15px;
            margin: 10px 0;
            min-height: calc(100vh - 240px);
        }

        .topControl {
            display: flex;
            align-items: center;
            gap: 30px;
            padding: 10px 0;

            .title {
                font-weight: 500;
                font-size: 16px;
            }

            .query {
                display: flex;
                align-items: center;
                gap: 5px;
            }

        }
    }

    span.notion {
        background: #D7E1FC;
        padding: 2px 4px;
        border-radius: 3px;
    }

</style>